import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Clock, Ticket, Activity } from 'lucide-react';
export function AgendaSection() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="agenda" className="py-24 bg-gray-50 relative" data-id="element-107" data-mp="hhj7emcor7mo">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108" data-mp="mfuit1impq70">
        <div className="text-center mb-16" data-id="element-109" data-mp="mhdxwosjtv77">
          <h2 className="text-4xl md:text-5xl text-brand-navy mb-4" data-id="element-110" data-mp="7r6sb9nn46nx">
            {['¿Qué', 'vas', 'a', 'vivir', 'el', '26', 'de', 'julio?'].map((word, i) => <motion.span key={i} initial={{
            opacity: 0,
            y: 30,
            filter: 'blur(10px)'
          }} whileInView={{
            opacity: 1,
            y: 0,
            filter: 'blur(0px)'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.15,
            ease: [0.22, 1, 0.36, 1]
          }} className="inline-block shimmer-text mr-3" data-id="element-111" data-mp="10fcdtymipzot" data-mpi={i}>
                  {word}
                </motion.span>)}
          </h2>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-2 text-base md:text-xl text-brand-cyan font-bold px-2" data-id="element-112" data-mp="2lba302kch5in">
            <div className="flex items-center gap-2" data-id="element-113" data-mp="1fnn675te0nz7">
              <Calendar className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0" data-id="element-114" data-mp="1fo6seyq2lyj1" />
              <span data-id="element-115" data-mp="1klyl3uyjhooa">26 de julio de 2026</span>
            </div>
            <span className="hidden md:inline text-gray-300 mx-2" data-id="element-116" data-mp="1plt9nruue266">|</span>
            <div className="flex items-center gap-2 text-center" data-id="element-117" data-mp="1pk00o5wrb5v0">
              <MapPin className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0" data-id="element-118" data-mp="1ukebfvpqstwq" />
              <span data-id="element-119" data-mp="1ym9d51bl59b1">Parque del Bienestar COMFAMA Llanogrande</span>
            </div>
          </motion.div>
        </div>

        {/* Timeline */}
        <div className="relative" data-id="element-120" data-mp="23e9f0zb7uca9">
          {/* Vertical Line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-1 bg-gray-200 transform md:-translate-x-1/2 rounded-full" data-id="element-121" data-mp="28bj0y4zec5tc"></div>

          {/* Timeline Item 1: Pre-event */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="relative flex flex-col md:flex-row items-start md:items-center justify-between mb-12 md:mb-20" data-id="element-122" data-mp="2ia8n49ybscfe">
            <div className="md:w-5/12 order-2 md:order-1 pl-12 md:pl-0 md:text-right mt-4 md:mt-0" data-id="element-123" data-mp="pdmq6isa3czg">
              <h3 className="text-2xl font-bold text-brand-navy mb-2" data-id="element-124" data-mp="ke9v5ar96zls">
                PRE-EVENTO
              </h3>
              <p className="text-brand-cyan font-semibold mb-3" data-id="element-125" data-mp="fnbg0ei047k4">
                Sábado 25 de julio
              </p>
              <div className="bg-white p-5 rounded-2xl shadow-md border border-gray-100 inline-block text-left md:text-right w-full" data-id="element-126" data-mp="ao8j5hc6d7n8">
                <h4 className="font-bold text-gray-800 mb-2 flex items-center md:justify-end gap-2" data-id="element-127" data-mp="1868m1336r3k1">
                  <Ticket className="w-5 h-5 text-brand-yellow" data-id="element-128" data-mp="13bukeixxk06x" />
                  Entrega de Kits
                </h4>
                <p className="text-sm text-gray-600 mb-1" data-id="element-129" data-mp="suhdaa170dm5">
                  MEDELLIN: Sabado 12:00 m - 8:00 pm
                </p>
                <p className="text-sm text-gray-600" data-id="element-130" data-mp="dyrwqres0sot">
                  LLANOGRANDE: Sábado 8:00 am - 5:00 pm
                </p>
              </div>
            </div>

            {/* Center Dot */}
            <div className="absolute left-4 md:left-1/2 w-8 h-8 bg-brand-yellow rounded-full border-4 border-white shadow-md transform -translate-x-1/2 flex items-center justify-center z-10 order-1 md:order-2" data-id="element-131" data-mp="16n70uiwddqld">
              <div className="w-2 h-2 bg-white rounded-full" data-id="element-132" data-mp="wvt2wfk2gyuc"></div>
            </div>

            <div className="md:w-5/12 order-3 hidden md:block" data-id="element-133" data-mp="11udvptwzog8r"></div>
          </motion.div>

          {/* Timeline Item 2: 5K Walk */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative flex flex-col md:flex-row items-start md:items-center justify-between mb-12 md:mb-20" data-id="element-134" data-mp="1pix2g50e4kyq">
            <div className="md:w-5/12 order-2 md:order-3 pl-12 md:pl-0 mt-4 md:mt-0" data-id="element-135" data-mp="2w39jbqkua51a">
              <div className="flex items-center gap-2 mb-2" data-id="element-136" data-mp="2w545t9bre57h">
                <Clock className="w-6 h-6 text-brand-cyan" data-id="element-137" data-mp="2r5hqmucdeew1" />
                <h3 className="text-2xl font-bold text-brand-navy" data-id="element-138" data-mp="353pmeyxo7a5m">7:00 AM</h3>
              </div>
              <p className="text-brand-cyan font-semibold mb-3 text-xl" data-id="element-139" data-mp="312m2o1ci4tz4">
                Caminata Canina Pet Lovers
              </p>
              <div className="bg-white p-6 rounded-2xl shadow-lg border-l-4 border-brand-cyan w-full" data-id="element-140" data-mp="kcfbgrv07xcy">
                <p className="text-gray-600 mb-4" data-id="element-141" data-mp="gbdb27pcpf9e">
                  Salida desde el Parque del Bienestar de COMFAMA Llanogrande,
                  por la Vereda 3 Puertas, vía Linares y Vereda Villachiquaga
                  hasta regresar al parque y disfrutar de muchas actividades
                  para toda la familia y mascotas.
                </p>
                <div className="space-y-2 bg-gray-50 p-4 rounded-xl" data-id="element-142" data-mp="3n64racn2j6qq">
                  <div className="flex justify-between items-center border-b border-gray-200 pb-2" data-id="element-143" data-mp="3n4aexmpv4my9">
                    <span className="text-sm font-medium text-gray-700" data-id="element-144" data-mp="2qe17ff6ow6xu">
                      1 Persona + 1 Mascota
                    </span>
                    <span className="font-bold text-brand-navy" data-id="element-145" data-mp="2zgk5zn3fzxea">$100.000</span>
                  </div>
                  <div className="flex justify-between items-center border-b border-gray-200 pb-2 pt-2" data-id="element-146" data-mp="347semgwy7eqe">
                    <span className="text-sm font-medium text-gray-700" data-id="element-147" data-mp="27ol3sizpjyd7">
                      1 Persona (Sin mascota)
                    </span>
                    <span className="font-bold text-brand-navy" data-id="element-148" data-mp="2bp52vs3udc1z">$70.000</span>
                  </div>
                  <div className="flex justify-between items-center pt-2" data-id="element-149" data-mp="245cjd4bxft9g">
                    <span className="text-sm font-medium text-gray-700" data-id="element-150" data-mp="1z95ap3s5c3nt">
                      Mascota adicional
                    </span>
                    <span className="font-bold text-brand-navy" data-id="element-151" data-mp="1q7xmjejcgj7g">$30.000</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Center Dot */}
            <div className="absolute left-4 md:left-1/2 w-10 h-10 bg-brand-cyan rounded-full border-4 border-white shadow-md transform -translate-x-1/2 flex items-center justify-center z-10 order-1 md:order-2" data-id="element-152" data-mp="1lap2t9ijs743">
              <Activity className="w-4 h-4 text-white" data-id="element-153" data-mp="17hpqfge2at0r" />
            </div>

            <div className="md:w-5/12 order-3 md:order-1 hidden md:block" data-id="element-154" data-mp="17fd2mmlmhofs"></div>
          </motion.div>

          {/* Timeline Item 3: Sports Fair */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="relative flex flex-col md:flex-row items-start md:items-center justify-between mb-12" data-id="element-155" data-mp="xj0a3s1tdgmm">
            <div className="md:w-5/12 order-2 md:order-1 pl-12 md:pl-0 md:text-right mt-4 md:mt-0" data-id="element-156" data-mp="22of75ghva5hx">
              <div className="flex items-center md:justify-end gap-2 mb-2" data-id="element-157" data-mp="27gyngl7xveqf">
                <h3 className="text-2xl font-bold text-brand-navy" data-id="element-158" data-mp="1tpbnaaavlm2d">
                  8:00 AM - 5:00 PM
                </h3>
                <Clock className="w-6 h-6 text-brand-green hidden md:block" data-id="element-159" data-mp="1xr6rpno3sfkd" />
              </div>
              <p className="text-brand-green font-semibold mb-3 text-xl md:text-2xl" data-id="element-160" data-mp="1jrx9yjk91dea">
                Feria Bazar
              </p>
              <div className="bg-white p-6 rounded-2xl shadow-lg border-r-4 border-brand-green w-full text-left md:text-right" data-id="element-161" data-mp="1orry4fcn3ovn">
                <div className="inline-block bg-brand-green px-3 py-1 rounded-full mb-4 uppercase tracking-wide text-xs md:text-base font-bold text-[#FFFFFF]" data-id="element-162" data-mp="1052gguw991mn">
                  Entrada Gratuita
                </div>
                <p className="text-gray-600 mb-4" data-id="element-163" data-mp="1a2qm4fveftjl">
                  Para todas las edades. Un día entero de diversión, deporte y
                  conexión.
                </p>
                <ul className="text-sm text-gray-700 space-y-2 inline-block text-left" data-id="element-164" data-mp="1j3y7xygqb1ws">
                  <li className="flex items-center gap-2" data-id="element-165" data-mp="1xsky6v7w9e2s">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-green" data-id="element-166" data-mp="1xs1htixw6xqv"></div>{' '}
                    Fútbol, Tenis y Pádel
                  </li>
                  <li className="flex items-center gap-2" data-id="element-167" data-mp="26szknxwlgz7v">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-green" data-id="element-168" data-mp="26tiwcwvnirdg"></div>{' '}
                    Charlas informativas y practicas
                  </li>
                  <li className="flex items-center gap-2" data-id="element-169" data-mp="2tspek58kobnb">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-green" data-id="element-170" data-mp="2p0xm1p5uvvuj"></div>{' '}
                    Zona de entretenimiento para mascotas y niños
                  </li>
                  <li className="flex items-center gap-2" data-id="element-171" data-mp="2jzrs5o0gm2jf">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-green" data-id="element-172" data-mp="2f3sxxjsg9qb3"></div>{' '}
                    Música en vivo
                  </li>
                  <li className="flex items-center gap-2" data-id="element-173" data-mp="3cofg5rclf60o">
                    <div className="w-1.5 h-1.5 rounded-full bg-brand-green" data-id="element-174" data-mp="37sgl5kwrepra"></div>{' '}
                    Gastronomía y comercio
                  </li>
                </ul>
              </div>
            </div>

            {/* Center Dot */}
            <div className="absolute left-4 md:left-1/2 w-10 h-10 bg-brand-green rounded-full border-4 border-white shadow-md transform -translate-x-1/2 flex items-center justify-center z-10 order-1 md:order-2" data-id="element-175" data-mp="2yt3cuvkdg785">
              <div className="w-3 h-3 bg-white rounded-full" data-id="element-176" data-mp="2tjdqqeyi79w"></div>
            </div>

            <div className="md:w-5/12 order-3 hidden md:block" data-id="element-177" data-mp="2rq3l154x4x5"></div>
          </motion.div>
        </div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center mt-16" data-id="element-178" data-mp="btpmy03mgl39">
          <a href="#tiquetes" onClick={e => scrollToSection(e, '#tiquetes')} className="inline-flex items-center justify-center gap-2 bg-brand-cyan hover:bg-blue-700 text-white px-10 py-5 rounded-full font-bold text-xl transition-all shadow-xl hover:shadow-cyan-500/40 transform hover:-translate-y-1" data-id="element-179" data-mp="qkyg2j6qgol5">
            Conoce mas detalles
          </a>
        </motion.div>
      </div>
    </section>;
}